module.exports = __webpack_public_path__ + "static/media/usaa-logo.290e47f4.svg";